import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export interface Crumb { label: string; path?: string; }

interface Props { items: Crumb[]; }

const SeoBreadcrumbs = ({ items }: Props) => (
  <nav aria-label="Breadcrumb" className="text-xs md:text-sm text-muted-foreground mb-6 font-body">
    <ol className="flex items-center flex-wrap gap-1.5">
      <li className="flex items-center gap-1.5">
        <Link to="/" className="hover:text-primary inline-flex items-center gap-1"><Home className="h-3.5 w-3.5" />Home</Link>
      </li>
      {items.map((c, i) => (
        <li key={i} className="flex items-center gap-1.5">
          <ChevronRight className="h-3.5 w-3.5 opacity-50" />
          {c.path ? (
            <Link to={c.path} className="hover:text-primary">{c.label}</Link>
          ) : (
            <span className="text-foreground font-medium">{c.label}</span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);

export default SeoBreadcrumbs;

/** Every ListItem must carry an `item` URL, otherwise Google Search Console
 *  reports `Missing field "item"`. Crumbs without their own path fall back to
 *  the current page URL. */
export const buildBreadcrumbJsonLd = (items: Crumb[], baseUrl: string, currentPath = "/") => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Home", item: baseUrl + "/" },
    ...items.map((c, i) => ({
      "@type": "ListItem",
      position: i + 2,
      name: c.label,
      item: baseUrl + (c.path ?? currentPath),
    })),
  ],
});